import { Platform } from "../constants";

import { RetentionScienceSetupImage } from "./components/retention-science-setup-image";
import { SetupSection } from "./components/setup-section";
import { OrderedList } from "./components/styled";
import { UTMParamTable } from "./components/utm-param-table";
import { URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.RETENTION_SCIENCE;

export const RetentionScienceDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const RetentionScienceSetup = () => (
  <>
    <SetupSection title="Input parameter pairs on the ’UTM Settings’ page.">
      <OrderedList variant="upper-alpha">
        <>
          Make sure ‘Disable automatic UTM tagging’ is toggled on
          <RetentionScienceSetupImage className="mt-4 mb-6" />
        </>
        <>
          Input the following parameter pairs
          <div className="h-4" />
          <UTMParamTable platform={PLATFORM} />
        </>
      </OrderedList>
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
